import { FC } from 'react';
import { TooltipTypeProps, TooltipPlacement, TooltipTheme } from './TypeProps';
import classNames from 'classnames';

import styles from './Tooltip.module.scss';

export const Tooltip: FC<TooltipTypeProps> = ({
  className,
  classNameTarget,
  classNameContent,
  classNameWrapper,
  children,
  placement = TooltipPlacement.TopStart,
  theme = TooltipTheme.Default,
  content,
}) => {
  return (
    <div className={classNames(styles.Wrapper, className)}>
      <div className={classNameTarget}>{children}</div>
      {!!content && (
        <div className={classNames(styles.WrapperTooltip, styles[placement], styles[theme], classNameWrapper)}>
          <div className={classNames(styles.Tooltip, classNameContent)}>{content}</div>
        </div>
      )}
    </div>
  );
};
